var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"a-button",class:{
        'a-button--disabled': _vm.disabled,
        'a-button--iconOnly': !!_vm.icon && !_vm.$slots.default,
        'a-button--icon': !!_vm.icon && !!_vm.$slots.default,
        'a-button--light': _vm.type === 'light',
        'a-button--light a-button--square': _vm.type === 'square',
        'a-button--fullwidth': _vm.type === 'fullwidth',
        'a-button--light a-button--fullwidth': _vm.type === 'fullwidth-light',
        'a-button--processing': _vm.processing || _vm.isProcessing
    },attrs:{"disabled":_vm.disabled,"type":_vm.submit === true ? 'submit' : 'button'},on:{"click":function($event){return _vm.handleClick($event)}}},[(_vm.icon)?_c('a-icon',{staticClass:"a-button__icon",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default"),(_vm.processing || _vm.isProcessing)?_c('a-icon',{staticClass:"a-button__spinner",attrs:{"icon":"SpinnerSmall"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }